import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import venueSlice, { fetchVenues } from 'store/venue'
import {
  Box,
  Chip,
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  Typography,
  makeStyles,
  Divider,
  DialogContent,
  Dialog,
  CircularProgress
} from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Formik, Form } from 'formik'
import { Warning } from '@material-ui/icons'

import ViewHeader from 'components/ViewHeader'
import ProgressButton from 'components/ProgressButton'
import {
  addEvent,
  fetchEventById,
  fetchEventTypes,
  removeAbstractOrPosterNumberFromEventTalks,
  removeEventTalks,
  removeSessionsAndTalks,
  resetEventStore,
  updateEventById
} from 'store/event'
import sponsorSlice, { getSponsors } from 'store/sponsor'
import { eventFormSchema, typesOfEvents } from 'schemas/event'
import { Add } from '@material-ui/icons'

import ActionBar from 'components/ActionBar'
import CustomTextField from 'components/Form/CustomTextField'
import CustomSelect from 'components/Form/CustomSelect'
import DateTimeInput from 'components/DateTimeInput'
import CustomBox from 'components/Form/CustomBox'
import moment from 'moment-timezone'
import { getDefaultTimezone } from 'utils/times'
import { colors } from 'utils/colors'
import { fetchModerators } from 'store/moderator'
import {
  caseInsensitiveSort,
  getWarningTextBasedOnEventTypesChange,
  getWarningTextIfEventPosterSessionChanged,
  removeUndefinedItemsFromArrayOfString
} from 'utils'
import { nanoid } from 'nanoid'
import Info from 'components/Info'
import { AssociatedPollMsg, EventTypes, speakerStatus } from 'constants/index'
import { getSpeakersAssociatedPolls } from 'store/speaker'
import pollingSlice, { alreadyUsedPoll, getSpeakerPolls, pollAttachOrDetach } from 'store/polling'
import ConfirmModal from 'components/ConfirmationModal'
import TextField from '@material-ui/core/TextField'
import VenueForm from '../venue/VenueForm'
import CustomPopup from 'components/CustomPopup'
import EventCardForm from 'views/admin/eventCards/EventCardForm'
import ModeratorForm from '../moderators/ModeratorForm'
import SponsorForm from '../sponsors/SponsorForm'
import { isEqual } from 'lodash'
import PollingForm from 'views/admin/subjects/PollingForm/PollingForm'
import ReactQuill from 'react-quill'
import { modules } from 'views/admin/settings/SettingForm/TemplateForm'
import ErrorMessage from 'components/ErrorMessage'

const basePath = '/admin'
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
}

const emptyQuestion = {
  title: '',
  options: [
    { optId: nanoid(), opt: '' },
    { optId: nanoid(), opt: '' }
  ]
}
const pollInitialValues = {
  title: '',
  speakerId: '',
  questions: [emptyQuestion]
}

const EventForm = () => {
  const classes = useStyles()
  const { eventId } = useParams()
  const dispatch = useDispatch()
  const history = useHistory()

  const [loading, setLoading] = useState(false)
  const [changedSpeakerId, setChangedSpeakerId] = useState('')
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false)
  const [openAddPollModal, setOpenAddPollModal] = useState(false)
  const [pollValues, setPollValues] = useState(pollInitialValues)
  const [confirmModal, setConfirmModal] = useState(false)
  const [loadingPolls, setLoadingPolls] = useState(false)

  const [isPosterSessionUpdated, setIsPosterSessionUpdated] = useState(false)

  const { event, eventTypes: cardColors, inProgress } = useSelector((state) => state.event)
  const [openVenueModal, setOpenVenueModal] = useState(false)
  const [openCardColorModal, setOpenCardColorModal] = useState(false)
  const [openModeratorModal, setOpenModeratorModal] = useState(false)
  const [openSponsorModal, setOpenSponsorModal] = useState(false)
  const [loadingSpeakers, setLoadingSpeakers] = useState(false)

  const [openModeratorDropdown, setOpenModeratorDropdown] = useState(false)
  const [openSponsorDropdown, setOpenSponsorDropdown] = useState(false)
  const { user } = useSelector((state) => state.auth)
  const { venues } = useSelector((state) => state.venue)
  const { speakers } = useSelector((state) => state.speaker)
  const { sponsors } = useSelector((state) => state.sponsor)
  const { conference } = useSelector((state) => state.conference)
  const { moderators } = useSelector((state) => state.moderator)
  const { polls } = useSelector((state) => state.polling)
  const defaultTimezone = getDefaultTimezone(conference?.timezone)

  const openPosterSessionConfirmationModal = () => setIsPosterSessionUpdated(true)
  const closePosterSessionConfirmationModal = () => setIsPosterSessionUpdated(false)

  const handleCloseModal = (formValues) => {
    if (isEqual(pollValues, formValues)) {
      setOpenAddPollModal(false)
      setPollValues(pollInitialValues)
    } else {
      setConfirmModal(true)
    }
  }

  const handleCloseConfirmModal = () => {
    setConfirmModal(false)
    setOpenAddPollModal(false)
    setPollValues(pollInitialValues)
  }

  const initialValues = {
    title: event?.title ?? '',
    eventType: event?.eventType ?? typesOfEvents[0].id,
    cardStyle: event?.cardStyle ?? '',
    keynotes: event?.keynotes ?? '',
    eventVenue: event?.eventVenue ?? '',
    sponsorId: event?.sponsorId || [],
    moderators: event?.moderators || [],
    isPosterSession: event?.isPosterSession ?? false,
    isClickable: event?.isClickable ?? false,
    startDate: event?.startDate
      ? moment(event?.startDate).tz(defaultTimezone)
      : localStorage.getItem('eventStartDate')
      ? moment(parseInt(localStorage.getItem('eventStartDate'))).tz(defaultTimezone)
      : conference?.startDate
      ? moment(conference?.startDate).tz(defaultTimezone)
      : null,
    endDate: event?.endDate
      ? moment(event?.endDate).tz(defaultTimezone)
      : localStorage.getItem('eventEndDate')
      ? moment(parseInt(localStorage.getItem('eventEndDate'))).tz(defaultTimezone)
      : conference?.endDate
      ? moment(conference?.endDate).tz(defaultTimezone)
      : null,
    speakerId: event?.speakerId ?? '',
    havePolls: event?.havePolls === true ? 'yes' : 'no',
    pollId: event?.pollId ?? ''
  }

  const goBack = () => {
    dispatch(resetEventStore())
    history.goBack()
  }

  const handleReloadSpeakers = async () => {
    setLoadingSpeakers(true)
    await dispatch(getSpeakersAssociatedPolls(user?.conferenceId))
    setLoadingSpeakers(false)
  }

  useEffect(() => {
    const unsubVenues = fetchVenues(user?.conferenceId, (venuesData) => {
      dispatch(venueSlice.actions.setVenues(venuesData))
    })
    dispatch(fetchEventTypes())
    dispatch(fetchModerators())
    dispatch(getSpeakersAssociatedPolls(user?.conferenceId))
    if (eventId) {
      dispatch(fetchEventById(eventId))
    }

    return () => unsubVenues && unsubVenues()
  }, [dispatch, eventId, user?.conferenceId])

  useEffect(() => {
    const unsub = getSponsors(user?.conferenceId, (data) => {
      dispatch(sponsorSlice.actions.setSponsors(caseInsensitiveSort(data, 'fullName')))
    })
    return () => unsub && unsub()
  }, [dispatch, user?.conferenceId])

  useEffect(() => {
    if (changedSpeakerId) {
      setLoadingPolls(true)
      const unsubSpeakerPolls = getSpeakerPolls(user?.conferenceId, changedSpeakerId, (data) => {
        dispatch(pollingSlice.actions.setPolls(data))
        setLoadingPolls(false)
      })
      return () => unsubSpeakerPolls && unsubSpeakerPolls()
    } else dispatch(pollingSlice.actions.setPolls([]))
  }, [dispatch, changedSpeakerId])

  useEffect(() => {
    if (event?.speakerId) setChangedSpeakerId(event?.speakerId)
  }, [event?.speakerId])

  const handleChange = (e) => {
    setChangedSpeakerId(e.target.value)
  }

  const handleCloseWarningModal = () => {
    setIsWarningModalOpen(false)
  }
  const onSubmit = async ({
    title,
    eventType,
    cardStyle,
    keynotes,
    eventVenue,
    sponsorId,
    isClickable,
    moderators,
    isPosterSession,
    startDate,
    endDate,
    havePolls,
    pollId,
    speakerId
  }) => {
    setLoading(true)
    const payload = {
      title: title.trim(),
      eventType: eventType.trim(),
      cardStyle: cardStyle.trim(),
      keynotes: keynotes.trim(),
      eventVenue: eventVenue.trim(),
      sponsorId: removeUndefinedItemsFromArrayOfString(sponsorId),
      isPosterSession:
        eventType === 'haveTalks' || eventType === 'haveSessions' ? isPosterSession : false,
      moderators:
        (eventType === 'standalone' && isClickable) || eventType === 'haveTalks'
          ? removeUndefinedItemsFromArrayOfString(moderators)
          : [],
      isClickable: eventType === 'standalone' ? isClickable : false,
      startDate: moment(startDate).utc().valueOf(),
      endDate: moment(endDate).utc().valueOf(),
      havePolls: havePolls === 'yes',
      speakerId: havePolls === 'yes' ? speakerId : '',
      pollId: havePolls === 'yes' ? pollId : ''
    }

    let newEventId = ''

    if (
      (eventId && payload.havePolls && event?.pollId !== payload.pollId) ||
      (!eventId && payload.havePolls)
    ) {
      const isAlreadyUsed = await alreadyUsedPoll(payload.pollId)
      if (isAlreadyUsed) {
        toast.warning(AssociatedPollMsg)
        setLoading(false)
        return
      }
    }

    if (eventId) {
      const previousEventType = event?.eventType
      const newEventType = payload?.eventType
      if (previousEventType !== newEventType && newEventType === EventTypes.STANDALONE) {
        if (previousEventType === EventTypes.HAVE_SESSIONS) {
          await removeSessionsAndTalks(eventId)
        } else if (previousEventType === EventTypes.HAVE_TALKS) {
          await removeEventTalks(eventId)
        }
      } else if (
        previousEventType === EventTypes.HAVE_SESSIONS &&
        newEventType === EventTypes.HAVE_TALKS
      ) {
        await removeSessionsAndTalks(eventId)
      } else if (
        previousEventType === EventTypes.HAVE_TALKS &&
        newEventType === EventTypes.HAVE_SESSIONS
      ) {
        await removeEventTalks(eventId)
      } else if (event?.isPosterSession !== isPosterSession) {
        await removeAbstractOrPosterNumberFromEventTalks(eventId)
      }
      await dispatch(updateEventById(eventId, payload))
      localStorage.setItem('eventStartDate', payload.endDate)
      localStorage.setItem('eventEndDate', payload.endDate + (payload.endDate - payload.startDate))
      goBack()
    } else {
      newEventId = await dispatch(
        addEvent({
          ...payload,
          createdAt: moment().utc().valueOf(),
          pinCode: payload.eventType !== EventTypes.HAVE_SESSIONS ? nanoid(6) : null
        })
      )
      localStorage.setItem('eventStartDate', payload.endDate)
      localStorage.setItem('eventEndDate', payload.endDate + (payload.endDate - payload.startDate))
    }
    // if any poll was associated already, detach the previously attached poll
    if (
      (eventId && event?.havePolls && !payload?.havePolls) ||
      (payload.havePolls && event?.pollId !== payload.pollId)
    ) {
      await pollAttachOrDetach(event?.pollId, {
        eventId: null,
        sessionId: null,
        talkId: null,
        alreadyUsed: false
      })
    }
    // if event has poll then attach the event with poll
    if (payload.havePolls && payload.pollId) {
      await pollAttachOrDetach(payload.pollId, {
        eventId: eventId ? eventId : newEventId,
        sessionId: '',
        talkId: '',
        alreadyUsed: true
      })
    }

    if (!eventId && newEventId) {
      if (eventType === 'standalone') {
        goBack()
      } else {
        const targetPage = eventType === 'haveTalks' ? 'talks' : 'sessions'
        history.push(`${basePath}/events/${newEventId}/${targetPage}`)
      }
      dispatch(resetEventStore())
    }
    toast(`Event ${eventId ? 'updated' : 'created'} successfully`, {
      type: 'success',
      autoClose: 3000
    })
    setLoading(false)
  }

  return (
    <CustomBox>
      <ViewHeader title={eventId ? 'Edit event' : 'Create event'}>
        <ActionBar actionText="Back" onAction={goBack} />
      </ViewHeader>
      {conference?.havePolls && eventId && event?.eventType === EventTypes.STANDALONE && (
        <Box sx={{ mb: '32px ' }}>
          <Info pinCode={event?.pinCode} />
        </Box>
      )}
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={eventFormSchema}
        onSubmit={onSubmit}>
        {({ values, setFieldValue, touched, errors, submitForm, isValid }) => (
          <Form>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={8}>
                <CustomTextField label="Event Title" name="title" type="text" />
              </Grid>
              <Grid item xs={12} lg={4}>
                <TextField
                  select
                  fullWidth
                  label="Venue"
                  variant="outlined"
                  error={Boolean(touched.eventVenue && errors.eventVenue)}
                  value={values.eventVenue}
                  onChange={(event) =>
                    event.target.value && setFieldValue('eventVenue', event.target.value)
                  }
                  helperText={touched.eventVenue && errors.eventVenue ? errors.eventVenue : null}>
                  {venues?.map((venue) => (
                    <MenuItem value={venue.id} key={venue.id}>
                      <Typography>{venue.venueText}</Typography>
                    </MenuItem>
                  ))}
                  <Divider />
                  <MenuItem onClick={() => setOpenVenueModal(true)}>
                    <Typography className={classes.buttonItem}>
                      <Add />
                      Create venue
                    </Typography>
                  </MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomSelect
                  inputLabel="Event Type"
                  options={typesOfEvents}
                  optionAttr="name"
                  name="eventType"
                />
              </Grid>
              {values && values?.eventType === 'standalone' ? (
                <Grid style={{ marginLeft: 20 }} item sm={12} md={4}>
                  <Typography>Is this event clickable?</Typography>
                  <RadioGroup row>
                    <FormControlLabel
                      control={<Radio />}
                      label="Yes"
                      checked={values && values.isClickable}
                      onChange={() => setFieldValue('isClickable', true)}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      label="No"
                      checked={values && !values.isClickable}
                      onChange={() => setFieldValue('isClickable', false)}
                    />
                  </RadioGroup>
                </Grid>
              ) : null}
              {values && values.eventType !== 'standalone' ? (
                <Grid style={{ marginLeft: 20 }} item sm={12} md={4}>
                  <Typography>Is poster session?</Typography>
                  <RadioGroup row>
                    <FormControlLabel
                      control={<Radio />}
                      label="Yes"
                      checked={values && values.isPosterSession}
                      onChange={() => setFieldValue('isPosterSession', true)}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      label="No"
                      checked={values && !values.isPosterSession}
                      onChange={() => setFieldValue('isPosterSession', false)}
                    />
                  </RadioGroup>
                </Grid>
              ) : null}
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12} lg={4}>
                    <DateTimeInput
                      value={values.startDate}
                      dateLabel="Event Start Date"
                      timeLabel="Event Start Time"
                      name="startDate"
                      is24hrFormat={conference?.is24hrFormat}
                      minDate={conference && moment(conference?.startDate).tz(conference?.timezone)}
                      maxDate={conference && moment(conference?.endDate).tz(conference?.timezone)}
                      onChange={(value) => {
                        setFieldValue('startDate', value)
                        if (!eventId) {
                          setFieldValue('endDate', value)
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <DateTimeInput
                      value={values.endDate}
                      dateLabel="Event End Date"
                      timeLabel="Event End Time"
                      name="endDate"
                      is24hrFormat={conference?.is24hrFormat}
                      minDate={conference && moment(conference?.startDate).tz(conference?.timezone)}
                      maxDate={conference && moment(conference?.endDate).tz(conference?.timezone)}
                      onChange={(value) => setFieldValue('endDate', value)}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {(values.eventType === 'standalone' && values.isClickable) ||
              values.eventType === 'haveTalks' ? (
                <Grid item xs={12} md={4}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    error={!!errors.moderators && touched.moderators}>
                    <InputLabel>Moderators</InputLabel>
                    <Select
                      multiple
                      open={openModeratorDropdown}
                      onOpen={() => setOpenModeratorDropdown(true)}
                      onClose={() => setOpenModeratorDropdown(false)}
                      name="moderators"
                      value={values.moderators}
                      onChange={(event) => {
                        const value = event.target.value
                        if (value) {
                          setFieldValue(
                            'moderators',
                            typeof value === 'string' ? value.split(',') : value
                          )
                        }
                      }}
                      input={<OutlinedInput id="select-multiple-chip" label="Moderator" />}
                      renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                          {selected.map(
                            (value) =>
                              value && (
                                <Chip
                                  style={{
                                    background: colors.indigo,
                                    color: 'white'
                                  }}
                                  key={value}
                                  label={moderators?.find((s) => s.id === value)?.fullName}
                                />
                              )
                          )}
                        </Box>
                      )}
                      MenuProps={MenuProps}>
                      {moderators &&
                        !!moderators.length &&
                        moderators?.map((o) => (
                          <MenuItem value={o.id} key={o.id}>
                            {o?.fullName}
                          </MenuItem>
                        ))}
                      <Divider />
                      <MenuItem
                        className={classes.nonSelectedMenu}
                        selected={false}
                        onClick={() => {
                          setOpenModeratorDropdown(false)
                          setOpenModeratorModal(true)
                        }}>
                        <Typography className={classes.buttonItem}>
                          <Add />
                          Create moderator
                        </Typography>
                      </MenuItem>
                    </Select>
                    {touched.moderators && <FormHelperText>{errors.moderators}</FormHelperText>}
                  </FormControl>
                </Grid>
              ) : null}
              <Grid item xs={12} md={4}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  error={!!errors.sponsorId && touched.sponsorId}>
                  <InputLabel>Sponsors</InputLabel>
                  <Select
                    multiple
                    open={openSponsorDropdown}
                    onOpen={() => setOpenSponsorDropdown(true)}
                    onClose={() => setOpenSponsorDropdown(false)}
                    name="sponsorId"
                    value={values.sponsorId}
                    onChange={(event) => {
                      const value = event.target.value
                      setFieldValue('sponsorId', value)
                    }}
                    input={<OutlinedInput id="select-multiple-chip" label="Sponsor" />}
                    renderValue={(selected) => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                        {selected.map(
                          (value) =>
                            value && (
                              <Chip
                                style={{
                                  background: colors.indigo,
                                  color: 'white'
                                }}
                                key={value}
                                label={sponsors?.find((s) => s.id === value)?.fullName}
                              />
                            )
                        )}
                      </Box>
                    )}
                    MenuProps={MenuProps}>
                    {sponsors &&
                      !!sponsors.length &&
                      sponsors?.map((o) => (
                        <MenuItem value={o.id} key={o.id}>
                          {o?.fullName}
                        </MenuItem>
                      ))}
                    <Divider />
                    <MenuItem
                      className={classes.nonSelectedMenu}
                      onClick={() => {
                        setOpenSponsorDropdown(false)
                        setOpenSponsorModal(true)
                      }}>
                      <Typography className={classes.buttonItem}>
                        <Add />
                        Create sponsor
                      </Typography>
                    </MenuItem>
                  </Select>
                  {touched.sponsorId && <FormHelperText>{errors.sponsorId}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={4}>
                <TextField
                  select
                  fullWidth
                  label="Card Color"
                  variant="outlined"
                  error={Boolean(touched.cardStyle && errors.cardStyle)}
                  value={values.cardStyle}
                  onChange={(event) =>
                    event.target.value && setFieldValue('cardStyle', event.target.value)
                  }
                  helperText={touched.cardStyle && errors.cardStyle ? errors.cardStyle : null}>
                  {cardColors?.map((cardColor) => (
                    <MenuItem value={cardColor.id} key={cardColor.id}>
                      <Box className={classes.menuItem}>
                        <Box
                          sx={{
                            width: '18px',
                            height: '18px',
                            borderRadius: '4px',
                            backgroundColor: cardColor.bgColor ?? ''
                          }}></Box>
                        <Typography>{cardColor.type}</Typography>
                      </Box>
                    </MenuItem>
                  ))}
                  <Divider />
                  <MenuItem onClick={() => setOpenCardColorModal(true)}>
                    <Typography className={classes.buttonItem}>
                      <Add />
                      Create card color
                    </Typography>
                  </MenuItem>
                </TextField>
              </Grid>

              {values &&
                ((values.eventType === 'standalone' && values.isClickable) ||
                  values.eventType !== 'standalone') && (
                  <Grid item xs={12}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                      <label className={classes.label}>Keynotes</label>
                      <ReactQuill
                        theme="snow"
                        modules={modules}
                        value={values.keynotes}
                        onChange={(value) => setFieldValue('keynotes', value)}
                        placeholder="Write keynotes here..."
                      />
                      <ErrorMessage message={touched?.keynotes && errors?.keynotes} />
                    </Box>
                  </Grid>
                )}

              {conference?.havePolls && values.eventType === EventTypes.STANDALONE && (
                <>
                  <Grid item xs={12}>
                    <Box className={classes.radioGroup}>
                      <Typography className={classes.radioLabel}>
                        Do you want to associate a poll with this Standalone Event?
                      </Typography>
                      <RadioGroup
                        row
                        value={values.havePolls}
                        onChange={(e) => setFieldValue('havePolls', e.target.value)}>
                        <FormControlLabel
                          control={<Radio size="small" />}
                          label={<Typography variant="body2">Yes</Typography>}
                          value="yes"
                        />
                        <FormControlLabel
                          control={<Radio size="small" />}
                          label={<Typography variant="body2">No</Typography>}
                          value="no"
                        />
                      </RadioGroup>
                    </Box>
                  </Grid>
                  {values.havePolls === 'yes' && (
                    <>
                      <Grid item xs={12} lg={6}>
                        {!loadingSpeakers && (
                          <TextField
                            select
                            fullWidth
                            className={classes.selectSpeakerMenu}
                            name="speakerId"
                            label="Speaker"
                            variant="outlined"
                            error={Boolean(touched.speakerId && errors.speakerId)}
                            value={values.speakerId}
                            onChange={(event) => {
                              setFieldValue('pollId', '')
                              event.target.value && setFieldValue('speakerId', event.target.value)
                              handleChange(event)
                            }}
                            helperText={
                              touched.speakerId && errors.speakerId ? errors.speakerId : null
                            }>
                            {speakers?.map((speaker) => (
                              <MenuItem
                                value={speaker.id}
                                key={speaker.id}
                                className={classes.listItem}>
                                {speaker?.isSubject && speaker?.fullName
                                  ? speaker?.fullName
                                  : speaker?.isSubject && !speaker?.fullName
                                  ? speaker.email
                                  : speaker.fullName}
                                {speaker?.isSubject &&
                                  speaker?.status === speakerStatus.PENDING && (
                                    <Chip
                                      size="small"
                                      className={classes.chip}
                                      color="primary"
                                      label={
                                        <Typography className={classes.chipLabel}>
                                          {speaker?.status === speakerStatus.PENDING
                                            ? 'Not Approved'
                                            : 'Approved'}
                                        </Typography>
                                      }
                                    />
                                  )}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                        {loadingSpeakers && (
                          <Box className={classes.loadingFieldBox}>
                            <CircularProgress size={20} />
                            <Typography>Loading speakers...</Typography>
                          </Box>
                        )}
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                          {!loadingPolls && (
                            <TextField
                              select
                              fullWidth
                              disabled={loadingPolls}
                              label="Associated Poll"
                              variant="outlined"
                              error={Boolean(touched.pollId && errors.pollId)}
                              value={values.pollId}
                              onChange={(event) =>
                                event.target.value && setFieldValue('pollId', event.target.value)
                              }
                              helperText={touched.pollId && errors.pollId ? errors.pollId : null}>
                              {polls?.map((poll) => (
                                <MenuItem value={poll.id} key={poll.id}>
                                  <Typography>{poll.title}</Typography>
                                </MenuItem>
                              ))}
                              <Divider />
                              <MenuItem onClick={() => setOpenAddPollModal(true)}>
                                <Typography className={classes.buttonItem}>
                                  <Add />
                                  Create poll
                                </Typography>
                              </MenuItem>
                            </TextField>
                          )}
                          {loadingPolls && (
                            <Box className={classes.loadingFieldBox}>
                              <CircularProgress size={20} />
                              <Typography>Loading polls...</Typography>
                            </Box>
                          )}
                        </Box>
                      </Grid>
                    </>
                  )}
                </>
              )}
            </Grid>
            <Grid container spacing={2} className={classes.actionButtons}>
              <Grid item>
                <Button size="large" onClick={goBack} disabled={inProgress || loading}>
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <ProgressButton
                  type={
                    !eventId ||
                    (eventId &&
                      event?.eventType === values.eventType &&
                      values.isPosterSession === event?.isPosterSession) ||
                    (eventId &&
                      event?.eventType === EventTypes.STANDALONE &&
                      values.eventType !== EventTypes.STANDALONE)
                      ? 'submit'
                      : 'button'
                  }
                  label="Save"
                  inProgress={inProgress || loading}
                  disabled={inProgress || loading}
                  onClick={() => {
                    if (
                      eventId &&
                      event?.eventType !== EventTypes.STANDALONE &&
                      event?.eventType !== values?.eventType
                    ) {
                      setIsWarningModalOpen(true)
                    } else if (
                      eventId &&
                      event?.eventType !== EventTypes.STANDALONE &&
                      event?.isPosterSession !== values?.isPosterSession
                    ) {
                      openPosterSessionConfirmationModal()
                    }
                  }}
                />
              </Grid>
            </Grid>
            <Dialog fullWidth maxWidth="xl" open={openAddPollModal}>
              <DialogContent className={classes.pollModalContent}>
                <PollingForm
                  forApproval={true}
                  editedPollId={null}
                  pollValues={pollValues}
                  speakerId={null}
                  conferenceId={user?.conferenceId}
                  associateSpeaker={true}
                  subjectId={null}
                  handleCloseModal={handleCloseModal}
                  handleCloseConfirmModal={() => setOpenAddPollModal(false)}
                  onSuccess={async (pollId, speakerId) => {
                    await handleReloadSpeakers()
                    setChangedSpeakerId(speakerId)
                    setFieldValue('speakerId', speakerId)
                    setFieldValue('pollId', pollId)
                  }}
                />
              </DialogContent>
            </Dialog>
            <Dialog
              fullWidth
              maxWidth="sm"
              open={confirmModal}
              onClose={() => setConfirmModal(false)}>
              <Box className={classes.warningModalHeader}>
                <Warning className={classes.warningIcon} />
                <Typography className={classes.warningTitle}>Warning</Typography>
              </Box>
              <DialogContent className={classes.modalContent}>
                <Typography variant="body2">
                  Any unsaved data will be lost. Press CANCEL to go back and save these changes, or
                  OK to discard these changes.
                </Typography>

                <Box className={classes.actions}>
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={handleCloseConfirmModal}>
                    ok
                  </Button>
                  <Button size="medium" onClick={() => setConfirmModal(false)}>
                    cancel
                  </Button>
                </Box>
              </DialogContent>
            </Dialog>
            <ConfirmModal
              dialogTitle="Warning"
              dialogText={getWarningTextBasedOnEventTypesChange(event?.eventType, values.eventType)}
              dialogText2="Do you still want to continue?"
              open={isWarningModalOpen}
              closeModal={handleCloseWarningModal}
              handleConfirm={async () => {
                if (isValid) {
                  await submitForm()
                }
              }}
              inProgress={loading || inProgress}
            />
            <ConfirmModal
              dialogTitle="Warning"
              dialogText={getWarningTextIfEventPosterSessionChanged(
                event?.isPosterSession,
                values?.isPosterSession
              )}
              dialogText2="Do you still want to continue?"
              open={isPosterSessionUpdated}
              closeModal={closePosterSessionConfirmationModal}
              handleConfirm={async () => {
                if (isValid) {
                  await submitForm()
                }
              }}
              inProgress={loading || inProgress}
            />
            <CustomPopup
              title="Create venue"
              maxWidth="lg"
              open={openVenueModal}
              onClose={() => setOpenVenueModal(false)}>
              <VenueForm
                displayContext="modal"
                onCloseModal={() => setOpenVenueModal(false)}
                onSuccess={(venueId) => {
                  setOpenVenueModal(false)
                  setFieldValue('eventVenue', venueId)
                }}
              />
            </CustomPopup>
            <CustomPopup
              title="Create card color"
              maxWidth="lg"
              open={openCardColorModal}
              onClose={() => setOpenCardColorModal(false)}>
              <EventCardForm
                displayContext="modal"
                onCloseModal={() => setOpenCardColorModal(false)}
                onSuccess={(cardColorId) => {
                  setOpenCardColorModal(false)
                  setFieldValue('cardStyle', cardColorId)
                }}
              />
            </CustomPopup>
            <CustomPopup
              title="Create moderator"
              maxWidth="md"
              open={openModeratorModal}
              onClose={() => setOpenModeratorModal(false)}>
              <ModeratorForm
                displayContext="modal"
                onCloseModal={() => setOpenModeratorModal(false)}
                onSuccess={(moderatorId) => {
                  setOpenModeratorModal(false)
                  setFieldValue(
                    'moderators',
                    values?.moderators?.length > 0
                      ? [...values.moderators, moderatorId]
                      : [moderatorId]
                  )
                }}
              />
            </CustomPopup>

            <CustomPopup
              title="Create sponsor"
              maxWidth="lg"
              open={openSponsorModal}
              onClose={() => setOpenSponsorModal(false)}>
              <SponsorForm
                displayContext="modal"
                onCloseModal={() => setOpenSponsorModal(false)}
                onSuccess={(sponsorId) => {
                  setOpenSponsorModal(false)
                  setFieldValue(
                    'sponsorId',
                    values?.sponsorId?.length > 0 ? [...values.sponsorId, sponsorId] : [sponsorId]
                  )
                }}
              />
            </CustomPopup>
          </Form>
        )}
      </Formik>
    </CustomBox>
  )
}
export default EventForm

const useStyles = makeStyles({
  label: {
    fontSize: '13px',
    letterSpacing: '0.5px',
    color: '#606060'
  },
  chipLabel: {
    fontSize: '13px',
    letterSpacing: '0.5px',
    fontWeight: 'bold'
  },
  selectSpeakerMenu: {
    '& .MuiOutlinedInput-root': {
      '& .MuiSelect-outlined.MuiSelect-outlined': {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem'
      }
    }
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  },
  chip: {
    background: '#c62828',
    color: '#FFFFFF'
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem'
  },
  buttonItem: {
    color: colors.indigo,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '0.3rem'
  },
  actionButtons: {
    marginTop: '16px',
    display: 'flex',
    justifyContent: 'end'
  },
  radioGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  },
  radioLabel: {
    fontWeight: 600,
    fontSize: '16px',
    color: '#2f2f2f'
  },
  warningModalHeader: {
    padding: '20px 20px 10px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  warningIcon: {
    color: '#ffa726'
  },
  warningTitle: {
    fontSize: '16px',
    fontWeight: 'bold'
  },
  modalContent: {
    padding: '4px 16px 4px 22px'
  },
  actions: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginBottom: '10px'
  },
  loadingFieldBox: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '1rem',
    gap: '1rem',
    height: '100%',
    border: '1px solid #dedede',
    borderRadius: '8px',
    width: '100%'
  },
  nonSelectedMenu: {
    backgroundColor: '#ffffff !important'
  }
})
